"use strict";

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _classPrivateFieldLooseBase(receiver, privateKey) { if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) { throw new TypeError("attempted to use private field on non-instance"); } return receiver; }

var id = 0;

function _classPrivateFieldLooseKey(name) { return "__private_" + id++ + "_" + name; }

import assert from "@brillout/assert";
import flatpickr from "flatpickr";
import "flatpickr/dist/flatpickr.css";
import { store } from "../store";
import { escape_html } from "../utils/escape_html";
export { TextInput, BooleanInput, SelectInput, ColorInput, DateInput, Button, PersistantInput };

var PersistantInput = /*#__PURE__*/function () {
  function PersistantInput(props) {
    _classCallCheck(this, PersistantInput);

    this._props = void 0;
    this._input_id = void 0;
    Object.defineProperty(this, _on_input_change, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _input_default, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _storage_key, {
      writable: true,
      value: void 0
    });
    this.input_tag = void 0;
    this.input_type = void 0;
    this._dom_el = void 0;
    this._input_el = void 0;
    this._props = props;
    var input_id = props.input_id,
        on_input_change = props.on_input_change,
        input_default = props.input_default;
    assert(input_id && on_input_change);
    this._input_id = input_id;
    _classPrivateFieldLooseBase(this, _on_input_change)[_on_input_change] = on_input_change;
    _classPrivateFieldLooseBase(this, _input_default)[_input_default] = input_default;
    _classPrivateFieldLooseBase(this, _storage_key)[_storage_key] = input_id;
  } // Public functions


  _createClass(PersistantInput, [{
    key: "input_get",
    value: function input_get() {
      return this._input_retriever();
    }
  }, {
    key: "has_stored_value",
    value: function has_stored_value() {
      return store.has_val(_classPrivateFieldLooseBase(this, _storage_key)[_storage_key]);
    }
  }, {
    key: "get_stored_value",
    value: function get_stored_value() {
      return store.get_val(_classPrivateFieldLooseBase(this, _storage_key)[_storage_key]);
    }
  }, {
    key: "set_stored_value",
    value: function set_stored_value(val) {
      store.set_val(_classPrivateFieldLooseBase(this, _storage_key)[_storage_key], val);
    }
  }, {
    key: "input_set",
    value: function input_set(val) {
      this.set_stored_value(val);

      this._input_modifier(val);

      _classPrivateFieldLooseBase(this, _on_input_change)[_on_input_change]();
    }
  }, {
    key: "init",
    value: function init() {
      var _this = this;

      var input_tag = this.input_tag,
          input_type = this.input_type;
      assert(input_tag);
      assert(input_type || input_tag !== "input");

      var _generate_input = generate_input(_objectSpread({
        input_tag: input_tag,
        input_type: input_type
      }, this._props)),
          dom_el = _generate_input.dom_el,
          input_el = _generate_input.input_el;

      this._dom_el = dom_el;
      this._input_el = input_el;

      if (this._init_dom) {
        this._init_dom();
      }

      var init_val = this.has_stored_value() ? this.get_stored_value() : _classPrivateFieldLooseBase(this, _input_default)[_input_default];

      if (init_val !== undefined) {
        this._input_modifier(init_val);
      }

      this._input_el.addEventListener(this._change_event, function () {
        var val = _this._input_retriever();

        _this.set_stored_value(val);

        _classPrivateFieldLooseBase(_this, _on_input_change)[_on_input_change]();
      }, false);
    }
  }, {
    key: "hide",
    value: function hide() {
      hide_show_el(this._dom_el, true);
    }
  }, {
    key: "show",
    value: function show() {
      hide_show_el(this._dom_el);
    } // To be overriden

  }, {
    key: "_input_retriever",
    value: function _input_retriever() {
      return this._input_el.value;
    }
  }, {
    key: "_input_modifier",
    value: function _input_modifier(val) {
      this._input_el.value = val;
    }
  }, {
    key: "_change_event",
    get: function get() {
      return "change";
    }
  }]);

  return PersistantInput;
}();

var _on_input_change = _classPrivateFieldLooseKey("on_input_change");

var _input_default = _classPrivateFieldLooseKey("input_default");

var _storage_key = _classPrivateFieldLooseKey("storage_key");

var BooleanInput = /*#__PURE__*/function (_PersistantInput) {
  _inherits(BooleanInput, _PersistantInput);

  function BooleanInput(args) {
    var _this2;

    _classCallCheck(this, BooleanInput);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(BooleanInput).call(this, args));
    _this2.input_tag = void 0;
    _this2.input_type = void 0;
    _this2.input_tag = "input";
    _this2.input_type = "checkbox";
    return _this2;
  }

  _createClass(BooleanInput, [{
    key: "_input_retriever",
    value: function _input_retriever() {
      return !!this._input_el.checked;
    }
  }, {
    key: "_input_modifier",
    value: function _input_modifier(val) {
      if (!!val) {
        this._input_el.setAttribute("checked", "true");
      } else {
        this._input_el.removeAttribute("checked");
      }
    }
  }, {
    key: "init",
    value: function init() {
      _get(_getPrototypeOf(BooleanInput.prototype), "init", this).call(this);

      this._dom_el["classList"]["add"]("pointer-cursor");
    }
  }]);

  return BooleanInput;
}(PersistantInput);

var TextInput = /*#__PURE__*/function (_PersistantInput2) {
  _inherits(TextInput, _PersistantInput2);

  function TextInput(args) {
    var _this3;

    _classCallCheck(this, TextInput);

    _this3 = _possibleConstructorReturn(this, _getPrototypeOf(TextInput).call(this, args));
    _this3.input_tag = void 0;
    _this3.input_type = void 0;
    _this3.input_tag = "input";
    _this3.input_type = "text";
    return _this3;
  }

  _createClass(TextInput, [{
    key: "init",
    value: function init() {
      _get(_getPrototypeOf(TextInput.prototype), "init", this).call(this);

      var input_placeholder = this._props.input_placeholder;

      if (input_placeholder) {
        this._input_el.placeholder = input_placeholder;
      }
    }
  }, {
    key: "_change_event",
    get: function get() {
      // `input` event seem to only be reliably fired for text inputs
      //  - https://caniuse.com/#feat=input-event
      return "input";
    }
  }]);

  return TextInput;
}(PersistantInput);

var SelectInput = /*#__PURE__*/function (_PersistantInput3) {
  _inherits(SelectInput, _PersistantInput3);

  _createClass(SelectInput, [{
    key: "refresh",
    value: function refresh() {
      this._init_dom();
    }
  }], [{
    key: "get_divider",
    value: function get_divider(text) {
      var divider_text;

      if (text) {
        divider_text = "─── " + text + " ───";
      } else {
        divider_text = "───────────────";
      }

      var divider_html = "<option disabled>" + divider_text + "</option>";
      return {
        divider_html: divider_html
      };
    }
  }]);

  function SelectInput(_ref) {
    var _this4;

    var input_options = _ref.input_options,
        args = _objectWithoutProperties(_ref, ["input_options"]);

    _classCallCheck(this, SelectInput);

    _this4 = _possibleConstructorReturn(this, _getPrototypeOf(SelectInput).call(this, args));
    _this4.input_tag = void 0;
    _this4.input_options = void 0;
    _this4.input_tag = "select";
    _this4.input_options = input_options;
    return _this4;
  }

  _createClass(SelectInput, [{
    key: "_init_dom",
    value: function _init_dom() {
      var _this5 = this;

      assert(this.input_options.length > 0, this._input_id);
      var innerHTML = "";
      this.input_options.forEach(function (option_arg) {
        innerHTML += _this5._generate_option_html(option_arg);
      });
      this._input_el.innerHTML = innerHTML;
    }
  }, {
    key: "add_options",
    value: function add_options(new_options) {
      var _this6 = this;

      var current_value = this._input_retriever();

      var current_option_values = Array.from(this._input_el.querySelector("option")).map(function (el) {
        return el.value;
      });
      var innerHTML = this._input_el.innerHTML;
      new_options.forEach(function (option_arg) {
        var _this6$_parse_option_ = _this6._parse_option_arg(option_arg),
            val = _this6$_parse_option_.val;

        if (val && current_option_values.includes(val)) {
          return;
        }

        innerHTML += _this6._generate_option_html(option_arg);
      });
      this._input_el.innerHTML = innerHTML;

      this._input_modifier(current_value);
    }
  }, {
    key: "_input_modifier",
    value: function _input_modifier(val) {
      assert(val, "empty select", val === "", this._input_el.id, {
        val: val
      });

      if (!this._input_el.querySelector('option[value="' + val + '"]')) {
        this._input_el.innerHTML = this._generate_option_html(val) + SelectInput.get_divider().divider_html + this._input_el.innerHTML;
      }

      _get(_getPrototypeOf(SelectInput.prototype), "_input_modifier", this).call(this, val);
    }
  }, {
    key: "_generate_option_html",
    value: function _generate_option_html(option_arg) {
      var _this$_parse_option_a = this._parse_option_arg(option_arg),
          val = _this$_parse_option_a.val,
          val_pretty = _this$_parse_option_a.val_pretty,
          divider_html = _this$_parse_option_a.divider_html;

      if (divider_html) {
        return divider_html;
      }

      return '<option label="' + val_pretty + '" value="' + val + '">' + escape_html(val_pretty) + "</option>";
    }
  }, {
    key: "_parse_option_arg",
    value: function _parse_option_arg(option_arg) {
      assert(option_arg, this._input_id, {
        option_arg: option_arg
      });
      var divider_html = option_arg.divider_html;

      if (divider_html) {
        return {
          divider_html: divider_html
        };
      }

      var val = option_arg.val || option_arg;
      assert(val && val.constructor === String, option_arg);
      var val_pretty = option_arg.val_pretty || val;
      assert(val_pretty.constructor === String, val_pretty);
      return {
        val: val,
        val_pretty: val_pretty
      };
    }
  }]);

  return SelectInput;
}(PersistantInput);

var DateInput = /*#__PURE__*/function (_PersistantInput4) {
  _inherits(DateInput, _PersistantInput4);

  function DateInput() {
    var _getPrototypeOf2;

    var _this7;

    _classCallCheck(this, DateInput);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this7 = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(DateInput)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this7.input_tag = "input";
    _this7.input_type = "datetime";
    return _this7;
  }

  _createClass(DateInput, [{
    key: "_init_dom",

    /*
    constructor(args) {
      super(args);
      this.input_tag = 'input';
      this.input_type = 'datetime';
    }
    */
    value: function _init_dom() {
      flatpickr(this._input_el, {
        enableTime: true
        /*
        dateFormat: "Y-m-d H:i",
        altInput: true,
        altFormat: "F j, Y",
        dateFormat: "Y-m-d",
        */

      });
    }
  }]);

  return DateInput;
}(PersistantInput);

var ColorInput = /*#__PURE__*/function (_PersistantInput5) {
  _inherits(ColorInput, _PersistantInput5);

  function ColorInput(args) {
    var _this8;

    _classCallCheck(this, ColorInput);

    _this8 = _possibleConstructorReturn(this, _getPrototypeOf(ColorInput).call(this, args));
    _this8.input_tag = void 0;
    _this8.input_type = void 0;
    _this8.input_tag = "input";
    _this8.input_type = "color";
    return _this8;
  }

  _createClass(ColorInput, [{
    key: "init",
    value: function init() {
      _get(_getPrototypeOf(ColorInput.prototype), "init", this).call(this);

      this._dom_el["classList"]["add"]("pointer-cursor");
    }
  }]);

  return ColorInput;
}(PersistantInput);

var Button = /*#__PURE__*/function () {
  function Button(_ref2) {
    var on_click = _ref2.on_click,
        text = _ref2.text,
        input_container = _ref2.input_container,
        _ref2$className = _ref2.className,
        className = _ref2$className === void 0 ? null : _ref2$className,
        id = _ref2.id;

    _classCallCheck(this, Button);

    this.on_click = void 0;
    this.text = void 0;
    this.input_container = void 0;
    this.className = void 0;
    this.id = void 0;
    this.dom_el = void 0;
    this.on_click = on_click;
    this.text = text;
    this.input_container = input_container;
    this.className = className;
    this.id = id;
  }

  _createClass(Button, [{
    key: "generate_dom",
    value: function generate_dom() {
      var _this9 = this;

      var dom_el = document.createElement("button");

      if (this.className) {
        dom_el.setAttribute("class", this.className);
      }

      dom_el.setAttribute("type", "button");
      dom_el.setAttribute("id", this.id);

      dom_el.onclick = function (ev) {
        ev.preventDefault();

        _this9.on_click();
      };

      dom_el.textContent = this.text;
      this.input_container.appendChild(dom_el);
      this.dom_el = dom_el;
    } // to-do: as mixin

  }, {
    key: "hide",
    value: function hide() {
      hide_show_el(this.dom_el, true);
    }
  }, {
    key: "show",
    value: function show() {
      hide_show_el(this.dom_el);
    }
  }]);

  return Button;
}();
/*
const global_debouncer.debounce = new GlobalDebouncer();

class GlobalDebouncer {
  constructor() {
    this._lastTimeout;
    requestAnimationFrame
    cancelAnimationFrame
  }

  debounce(fn) {
    return () => {

      fn();
    };
  }
}
*/


function generate_input(_ref3) {
  var input_tag = _ref3.input_tag,
      input_type = _ref3.input_type,
      input_id = _ref3.input_id,
      input_description = _ref3.input_description,
      input_width = _ref3.input_width,
      input_container = _ref3.input_container;
  assert(input_tag);
  assert(input_type || input_tag !== "input");
  assert(input_id);
  assert(input_container, {
    input_id: input_id
  });
  var dom_el = document.createElement("label");
  assert(["select", "input"].includes(input_tag));
  var input_el = document.createElement(input_tag);
  input_el.id = input_id;
  if (input_type) input_el.setAttribute("type", input_type);
  var description_el;

  if (input_description) {
    description_el = document.createElement("span");
    description_el.textContent = input_description; //+'&nbsp;';
  }

  if (input_type === "checkbox") {
    dom_el.appendChild(input_el);

    if (description_el) {
      dom_el.appendChild(description_el);
    }
  } else {
    if (description_el) {
      dom_el.appendChild(description_el);
    }

    dom_el.appendChild(input_el);
  }

  if (input_width) {
    input_el.style.width = input_width;
  }

  input_container.appendChild(dom_el);
  return {
    dom_el: dom_el,
    input_el: input_el
  };
}

function hide_show_el(el) {
  var to_hide = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (to_hide) {
    el.setAttribute("disabled", "true");
  } else {
    el.removeAttribute("disabled");
  }

  el.style.width = to_hide ? "0px" : "";
  el.style.height = to_hide ? "0px" : "";
  el.style.visibility = to_hide ? "hidden" : "visible";
  el.style.position = to_hide ? "absolute" : "";
  el.style.zIndex = to_hide ? "-1" : "";
}